<script>
  import { onDestroy, onMount } from 'svelte';
  import {_} from 'svelte-i18n';
  import PreviewCardTopPanel from '../../custom/PreviewCard/components/PreviewCardTopPanel.svelte'
  import GeneralLayout from '../../layouts/GeneralLayout.svelte'
  import Comments from '../../custom/Comments/Comments.svelte'
  import PublicateItem from './PublicateItem.svelte'
  import Likes from '../../custom/Likes.svelte'

  import { init, sendPublicationViewLog } from './services'
  import { isSuccessLoading, post } from './store'
  import { info_client } from '../../stores';
  import { inview } from '../../../actions/inview';

  export let params = {}

  let openPublicationTimer; // Таймер для лога 'open'
  let readPublicationTimer; // Таймер для лога 'read'
  let isEndAlreadySeen = false;

  $: id_publicate = params.publ_id
  $: progress = Math.floor($post?.i_view)
  $: is_show_view_button = $post?.is_show_view_button

  $: {
    init(id_publicate)
    isEndAlreadySeen = false;
    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }, 100)
  }

  $: videoCount = $post?.publication_items?.map(({ video_url, video_url_2 }) => video_url || video_url_2)?.filter(Boolean)?.length

  const isMobileApp = JSON.parse(localStorage.getItem('from_mobile')) === true;

  const delayedLogger = (body) => {
    return setTimeout(() => {
      sendPublicationViewLog(body);
    }, 2000);
  };

  const sendPublicationLogStatus = (action) => {
    const body = JSON.stringify({ publication: id_publicate, action });
    
    if (action === 'open') {
      openPublicationTimer = delayedLogger(body);
    } else {
      readPublicationTimer = delayedLogger(body);
    }
  };

  const clickToUrlHandler = (event) => {
    if (event.target.tagName !== 'A') {
      return;
    }

    if (
      event.target.href.includes('transfer-to-season-31') || 
      event.target.href.includes('transfer-to-physical-2.0')
    ) {
      event.preventDefault();
      window.open('pht://navigate?to=perekhod-v-potok');
    }
  }

  const handlePublicationEndInview = (event) => {
    if (!$isSuccessLoading && !$post) {
      return;
    }
    
    const entry = event.detail;
    const isEndIntersecting = entry.isIntersecting && entry.intersectionRatio == 1;
    if (isEndIntersecting && !isEndAlreadySeen) {
      sendPublicationLogStatus('read');
      isEndAlreadySeen = true;
    }
  };

  onMount(() => {
    if (isMobileApp) {
      document.addEventListener('click', clickToUrlHandler);
    }

    sendPublicationLogStatus('open');
  })

  onDestroy(() => {
    clearTimeout(openPublicationTimer);
    clearTimeout(readPublicationTimer);

    if (isMobileApp) {
      document.removeEventListener('click', clickToUrlHandler);
    }
  })
</script>

<GeneralLayout isShowBackButton fixBottomPanel>
  {#if $post}
    {#if $post.videos.length > 1 && !$info_client.is_staff && is_show_view_button}
      <div class="progress">
        <div class="progress__wrapper">
          <div class="progress__wrapper-line" style:width={`${progress}%`} />
        </div>
        <div class="progress__text">{$_('viewed')} {progress}%</div>
      </div>
    {/if}

    <div class='title__text'>
      <PreviewCardTopPanel
        fixPublication={$post.fix}
        additional_content={$post.additional_content}
        feed_tags={$post.feed_tags}
      />

      <div class="publication-title">{$post.title}</div>
      <div class="publication-preview-text">{$post.preview_text}</div>
    </div>

    {#if $post.publication_items}
      {#each $post.publication_items as item}
        <PublicateItem 
          {videoCount} 
          {...item} 
          {id_publicate} 
          {is_show_view_button}
        />
      {/each}
    {/if}

    <div class="anchor"></div>
    {#await new Promise(resolve => setTimeout(resolve, 300))}
      <span class="line"></span>
    {:then}
      <span
        class='line'
        use:inview={{ threshold: 1 }}
        on:inview={handlePublicationEndInview}
      ></span>
    {/await}

    <Likes data={$post} hideLikesAndComments={$info_client?.flow?.is_green} />
    
    {#if $isSuccessLoading}
      <Comments 
        {id_publicate}
        disable_comments={$post.disable_comments}
      />
    {/if}
  {/if}
</GeneralLayout>

<style lang="scss">
  .progress {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    margin-bottom: 16px;

    @media (max-width: 576px) {
      margin-top: 30px;
    }

    &__wrapper {
      width: 100%;
      height: 8px;
      background: #EFF1FD;
      border-radius: 100px;
      overflow: hidden;

      &-line {
        background: #576CED;
        height: inherit;
      }
    }
    
    &__text {
      color: #576CED;
      font-size: 12px;
      line-height: 18px;
      font-weight: 500;
      white-space: nowrap;
    }
  }
  .publication-title {
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: 0em;
    margin-top: 8px;
    margin-bottom: 16px;
    color: #37352F;
  }

  .publication-preview-text {
    font-size: 16px;
    line-height: 28px;
    color: #37352F;
    margin-bottom: 16px;
  }
  
  .line { 
    content: ' ';
    background: #E0E8F6;
    width: 100%;
    height: 1px;
    float: left;
    margin-bottom: 16px;
  }
</style>
